module.exports = __webpack_public_path__ + "img/db_gift_left.181235fb.png";